import { useAuthStore } from "../stores/auth"
import { isPublicRoutePath } from '~/utils/public-routes'

export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only run on client
  if (process.server) return

  const authStore = useAuthStore()
  const { $checkAuth } = useNuxtApp()

  if (isPublicRoutePath(to.path)) {
    return
  }

  // Await the check so the protected page doesn't mount (and fire its own
  // queries) before we know whether the session is still valid. The check
  // is deduped with the plugin's in-flight refresh, so this doesn't add a
  // second network round trip when other callers are already refreshing.
  if (authStore.shouldRecheck()) {
    // Pass `to.path` — `router.currentRoute` inside $checkAuth still points
    // at `from` during navigation, so without this a stale-bounce from a
    // public route to a protected one would skip handleLogout.
    const isValid = await $checkAuth(to.path)
    if (!isValid) {
      return navigateTo('/login')
    }
  } else if (!authStore.isAuthenticated) {
    return navigateTo('/login')
  }
})
